import React, { createContext, useContext, useState } from 'react';

const Step5DataContext = createContext();

export const Step5DataProvider = ({ children }) => {
  const [installmentsForDiscount, setInstallmentsForDiscount] = useState([]);
  const [discountHistory, setDiscountHistory] = useState([]);
  const [appliedDiscountNames, setAppliedDiscountNames] = useState([]);
  const [totalAmount, setTotalAmount] = useState('');
  const [finalAmount, setFinalAmount] = useState('');
  const [quesbanksection, setQuesbanksection] = useState([]); // Assuming this already exists and matches your structure
  const [submissionData, setSubmissionData] = useState(null);
  const [hostelDetail, setHostelDetail] = useState([]);
  const [selectedQuestionBankName, setSelectedQuestionBankName] = useState('');

  return (
    <Step5DataContext.Provider
      value={{
        installmentsForDiscount,
        discountHistory,
        appliedDiscountNames,
        totalAmount,
        finalAmount,
        quesbanksection,
        setQuesbanksection,
        submissionData,
        setSubmissionData,
        selectedQuestionBankName,
        setSelectedQuestionBankName,
        setHostelDetail,
        hostelDetail
      }}
    >
      {children}
    </Step5DataContext.Provider>
  );
};

export const useStep5Data = () => {
  const context = useContext(Step5DataContext);
  if (!context) {
    throw new Error('useStep5Data must be used within a Step5DataProvider');
  }
  return context;
};